<mat-card appearance="outlined" fxFlex="100%" fxFlex.gt-xs="450px">
  @if (initStatus === 'loading' || isLoading) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  }

  <div id="header" fxLayout="column" fxLayoutAlign="start center">
    <mat-icon color="warn">settings_backup_restore</mat-icon>

    <h1>{{ 'MAIN.FORGOT_PASSWORD.TITLE_A' | translate }}</h1>
    <h3>{{ 'MAIN.FORGOT_PASSWORD.TITLE_B' | translate }}</h3>
  </div>

  @if (initStatus === 'done') {
    <mat-card-content>
      @if (requestResetForm !== undefined) {
        <form [formGroup]="requestResetForm" (ngSubmit)="requestReset()" fxLayout="column" fxLayoutGap="5px">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'COMMON.FORM.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="email" required autofocus>
            @if (requestResetForm.get('email').invalid) {
              <mat-error>{{ 'COMMON.REGEX.EMAIL.INVALID' | translate }}</mat-error>
            }
          </mat-form-field>
          <div class="buttons-row" fxFlex="row" fxLayoutAlign="end">
            <button mat-raised-button color="accent" [disabled]="isLoading || requestResetForm.invalid" type="submit">
              {{ 'MAIN.FORGOT_PASSWORD.RESET.BUTTON' | translate }}
            </button>
          </div>
        </form>
      }
      @if (resetPasswordForm !== undefined) {
        <form [formGroup]="resetPasswordForm" (ngSubmit)="setNewPassword()" fxLayout="column" fxLayoutGap="5px">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'COMMON.FORM.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="email" required autofocus autocomplete="email">
            @if (resetPasswordForm.get('email').invalid) {
              <mat-error>{{ 'COMMON.REGEX.EMAIL.INVALID' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'MAIN.FORGOT_PASSWORD.NEW_PASSWORD.INPUT' | translate }}</mat-label>
            <input matInput [type]="passwordVisible ? 'text' : 'password'" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%€^&*\-+/_.,:;=|'<>{}()\[\]]).{10,}$" formControlName="password" required autofocus autocomplete="new-password">
            <button mat-icon-button color="primary" (click)="passwordVisible = !passwordVisible" matSuffix><mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon></button>
            <mat-hint class="password-conditions">
              <ul>
                <li>
                  <mat-icon [color]="resetPasswordForm.get('password').getError('NotLongEnough') === true ? 'warn' : 'accent'">{{ resetPasswordForm.get('password').getError('NotLongEnough') === true ? 'error' : 'done' }}</mat-icon> 10 caractères ou plus
                </li>
                <li>
                  <mat-icon [color]="resetPasswordForm.get('password').getError('NoDigit') === true ? 'warn' : 'accent'">{{ resetPasswordForm.get('password').getError('NoDigit') === true ? 'error' : 'done' }}</mat-icon> Chiffre
                </li>
                <li>
                  <mat-icon [color]="resetPasswordForm.get('password').getError('NoLowerCase') === true ? 'warn' : 'accent'">{{ resetPasswordForm.get('password').getError('NoLowerCase') === true ? 'error' : 'done' }}</mat-icon> Minuscule
                </li>
                <li>
                  <mat-icon [color]="resetPasswordForm.get('password').getError('NoUpperCase') === true ? 'warn' : 'accent'">{{ resetPasswordForm.get('password').getError('NoUpperCase') === true ? 'error' : 'done' }}</mat-icon> Majuscule
                </li>
                <li>
                  <mat-icon [color]="resetPasswordForm.get('password').getError('NoSpecialChar') === true ? 'warn' : 'accent'">{{ resetPasswordForm.get('password').getError('NoSpecialChar') === true ? 'error' : 'done' }}</mat-icon> Caractère spécial
                </li>
              </ul>
            </mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'MAIN.FORGOT_PASSWORD.NEW_PASSWORD.CONFIRM.INPUT' | translate }}</mat-label>
            <input matInput type="password" formControlName="confirmPassword" required autocomplete="new-password">
            @if (resetPasswordForm.get('confirmPassword').getError('NotEqualTo') === 'password') {
              <mat-error>
                {{ 'COMMON.REGEX.NOT_SAME_PASSWORD' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <div class="buttons-row" fxFlex="row" fxLayoutAlign="end">
            <button mat-raised-button color="accent" [disabled]="isLoading || disableSubmit || resetPasswordForm.invalid" type="submit">
              {{ 'SHARED.BUTTONS.RESET' | translate }}
            </button>
          </div>
        </form>
      }
    </mat-card-content>
  }
</mat-card>
